export const weaponExp = [
  [
      0,
      275,
      700,
      1300,
      2100,
      3125,
      4400,
      5950,
      7800,
      9975,
      12475,
      15350,
      18600,
      22250,
      26300,
      30800,
      35750,
      41150,
      47050,
      53475,
      60400,
      68250,
      76675,
      85725,
      95400,
      105725,
      116700,
      128350,
      140700,
      153750,
      167550,
      182075,
      197375,
      213475,
      230375,
      248075,
      266625,
      286025,
      306300,
      327475,
      349525,
      373675,
      398800,
      424925,
      452075,
      480275,
      509525,
      539850,
      571275,
      603825,
      637475,
      674025,
      711800,
      750800,
      791075,
      832625,
      875475,
      919625,
      965125,
      1011975,
      1060200,
      1112275,
      1165825,
      1220875,
      1277425,
      1335525,
      1395175,
      1456400,
      1519200,
      1583600,
      1649625,
      1720700,
      1793525,
      1868100,
      1944450,
      2022600,
      2102600,
      2184450,
      2268150,
      2353725,
      2441225,
      2544500,
      2660575,
      2791000,
      2937500,
      3102050,
      3286825,
      3494225,
      3727000,
      3988200
  ],
  [
      0,
      400,
      1025,
      1925,
      3125,
      4675,
      6625,
      8975,
      11775,
      15075,
      18875,
      23225,
      28150,
      33675,
      39825,
      46625,
      54125,
      62325,
      71275,
      81000,
      91500,
      103400,
      116175,
      129875,
      144525,
      160150,
      176775,
      194425,
      213125,
      232900,
      253800,
      275825,
      299025,
      323400,
      349000,
      375825,
      403925,
      433325,
      464050,
      496125,
      529550,
      566125,
      604200,
      643800,
      684950,
      727675,
      772000,
      817950,
      865550,
      914850,
      965850,
      1021225,
      1078450,
      1137550,
      1198575,
      1261525,
      1326450,
      1393350,
      1462275,
      1533250,
      1606300,
      1685200,
      1766325,
      1849725,
      1935425,
      2023450,
      2113825,
      2206575,
      2301725,
      2399300,
      2499350,
      2607025,
      2717350,
      2830350,
      2946050,
      3064475,
      3185675,
      3309675,
      3436500,
      3566175,
      3698750,
      3855225,
      4031100,
      4228700,
      4450675,
      4699975,
      4979925,
      5294175,
      5646875,
      6042650
  ],
  [
      0,
      600,
      1550,
      2900,
      4700,
      7025,
      9950,
      13475,
      17675,
      22625,
      28325,
      34850,
      42250,
      50550,
      59775,
      69975,
      81225,
      93525,
      106950,
      121550,
      137300,
      155150,
      174325,
      194875,
      216850,
      240300,
      265250,
      291725,
      319775,
      349450,
      380800,
      413850,
      448650,
      485225,
      523625,
      563875,
      606025,
      650125,
      696225,
      744350,
      794500,
      849375,
      906500,
      965900,
      1027625,
      1091725,
      1158225,
      1227150,
      1298550,
      1372500,
      1449000,
      1532075,
      1617925,
      1706575,
      1798125,
      1892550,
      1989950,
      2090300,
      2193700,
      2300175,
      2409750,
      2528100,
      2649800,
      2774900,
      2903450,
      3035500,
      3171075,
      3310200,
      3452925,
      3599300,
      3749375,
      3910900,
      4076400,
      4245900,
      4419450,
      4597100,
      4778900,
      4964900,
      5155150,
      5349675,
      5548550,
      5783275,
      6047100,
      6343500,
      6676475,
      7050425,
      7470350,
      7941725,
      8470775,
      9064450
  ]
];